import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full 2xl:w-[50%] mx-auto" }
const _hoisted_2 = { class: "flex gap-6 items-center mt-6 mb-3" }
const _hoisted_3 = { class: "font-semibold text-base text-center text-gray-900" }
const _hoisted_4 = { class: "flex flex-col items-center justify-center mt-6" }
const _hoisted_5 = { class: "flex justify-between items-center p-4" }
const _hoisted_6 = { class: "font-semibold text-sm" }
const _hoisted_7 = { class: "inline-flex relative items-center cursor-pointer" }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-transparent dark:peer-focus:ring-blue-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "p-4 pt-1"
}
const _hoisted_11 = { class: "font-normal text-sm pb-3 text-gray-600" }
const _hoisted_12 = { class: "flex items-center w-full gap-4" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = ["disabled", "onUpdate:modelValue"]
const _hoisted_16 = { class: "ml-2 text-sm font-medium" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = ["onUpdate:modelValue", "disabled"]
const _hoisted_19 = { class: "ml-2 text-sm font-medium" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "en-ZA" }, "English ZA", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "en-GB" }, "English GB", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "en-AU" }, "English AU", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "af-ZA" }, "Afrikaans", -1)
const _hoisted_25 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "flex justify-between items-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "font-semibold text-sm" }
const _hoisted_31 = { class: "flex justify-end items-end w-[100%] mt-6" }
const _hoisted_32 = { class: "font-semibold text-sm" }
const _hoisted_33 = { class: "font-semibold text-sm" }

import { onMounted, ref } from 'vue';
import { defaultGrades, generateUniqueUID } from './constants/defaults';
import { TrashIcon } from "@heroicons/vue/24/outline";
import { NewClassTeacher } from '@/interfaces/school-structure.interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddGradesComponent',
  props: {
    step: {},
    teachers: {},
    newGrades: {}
  },
  emits: ["handleBack", "handleNext", "update:grades"],
  setup(__props: any, { emit }) {

const props = __props;





// Grades Object
const selectedGrades = ref(defaultGrades());

const onHandleNext = () => {
  emit('update:grades', selectedGrades.value);
  emit('handleNext');
};

// Function to add a new class to the specific grade
const addClass = (gradeIndex: any) => {
  selectedGrades.value[gradeIndex].classes.push({
    tempId: generateUniqueUID(),
    name: "",
    teacher: "",
    subject: "",
    gradeLevel: parseInt(selectedGrades.value[gradeIndex].grade),
    preferredLanguage: "",
    english: false,
    maths: false,
    englishTeachers: {
    },
    mathsTeachers: {
    },
  });
};

onMounted(() => {
  selectedGrades.value = props.newGrades;
});

// Function to remove a class from a specific grade
const removeClass = (gradeIndex: number, classIndex: number) => {
  selectedGrades.value[gradeIndex].classes.splice(classIndex, 1);
};

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "flex gap-6 items-center",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('handleBack')))
      }, [
        _createVNode(_component_rl_icon, {
          icon: 'rl-back-arrow',
          title: 'rl back arrow',
          "aria-hidden": "true"
        }),
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("add_grades_class_component.step_2.title")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedGrades.value, (grade, gradeIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: gradeIndex,
          class: "border border-gray-200 rounded-lg mt-4 flex flex-col w-[100%]"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("add_grades_class_component.step_2.grade")) + " " + _toDisplayString(grade.grade), 1),
            _createElementVNode("label", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((grade.selected) = $event),
                class: "sr-only peer"
              }, null, 8, _hoisted_8), [
                [_vModelCheckbox, grade.selected]
              ]),
              _hoisted_9
            ])
          ]),
          (grade.selected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("add_grades_class_component.step_2.subject")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grade.classes, (classItem, classIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: classIndex,
                    class: "flex justify-around items-center mb-3"
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((classItem.name) = $event),
                        class: "bg-white text-gray-500 text-base rounded-lg border w-[124px] border-gray-300 block p-2.5 py-2",
                        placeholder: "Class Name",
                        required: ""
                      }, null, 8, _hoisted_13), [
                        [_vModelText, classItem.name]
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          disabled: classItem.maths,
                          "onUpdate:modelValue": ($event: any) => ((classItem.english) = $event),
                          class: _normalizeClass('w-4 h-4 bg-white border border-gray-300 rounded-[4px] outline-none text-blue-600 focus:ring-blue-600 focus:ring-0 ' +
                  (classItem.maths ? 'cursor-not-allowed' : 'cursor-pointer')
                  )
                        }, null, 10, _hoisted_15), [
                          [_vModelCheckbox, classItem.english]
                        ]),
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("add_grades_class_component.step_2.english")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((classItem.maths) = $event),
                          disabled: classItem.english,
                          class: _normalizeClass('w-4 h-4 bg-white border border-gray-300 rounded-[4px] outline-none text-blue-600 focus:ring-blue-600 focus:ring-0 ' +
                  (classItem.english
                    ? 'cursor-not-allowed'
                    : 'cursor-pointer')
                  )
                        }, null, 10, _hoisted_18), [
                          [_vModelCheckbox, classItem.maths]
                        ]),
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("add_grades_class_component.step_2.maths")), 1)
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((classItem.preferredLanguage) = $event),
                        class: "w-28 border border-gray-300 px-[14px] shadow-box py-2 bg-white rounded-lg text-sm"
                      }, _hoisted_25, 8, _hoisted_20), [
                        [_vModelSelect, classItem.preferredLanguage]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (removeClass(gradeIndex, classIndex)),
                        class: "flex items-center text-red-600"
                      }, [
                        _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                      ], 8, _hoisted_27)
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (addClass(gradeIndex)),
                    class: "flex gap-[6px] items-center rounded-[1.25rem] mt-6 justify-center text-gray-600"
                  }, [
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-plus',
                      title: 'rl plus',
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("h1", _hoisted_30, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
                  ], 8, _hoisted_29)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_31, [
        (_ctx.teachers.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "px-[14px] py-[10px] text-white bg-blue-600 border border-blue-600 rounded-lg",
              onClick: onHandleNext
            }, [
              _createElementVNode("h1", _hoisted_32, _toDisplayString(_ctx.$t("add_grades_class_component.btn_next")) + " " + _toDisplayString(_ctx.step + 1), 1)
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "px-[14px] py-[10px] text-white bg-blue-600 border border-blue-600 rounded-lg",
              onClick: onHandleNext
            }, [
              _createElementVNode("h1", _hoisted_33, _toDisplayString(_ctx.$t("add_grades_class_component.btn_no_teachers_complete")), 1)
            ]))
      ])
    ])
  ]))
}
}

})